var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CheckFcsAgreement',{attrs:{"tournament-id":_vm.tournamentId}}),_c('CheckFcsAccount',{attrs:{"tournament-id":_vm.tournamentId}}),_c('PersonalDataSoloRequired',{attrs:{"tournament-id":_vm.tournamentId}}),_c('PersonalDataTeamRequired',{attrs:{"tournament-id":_vm.tournamentId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }